import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "./baseQuery";

export const npsAPI = createApi({
  reducerPath: "npsAPI",
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getNPSDashboard: builder.query({
      query: (params) => {
        return {
          url: `/api/reports/nps/dashboard/`,
          params,
        };
      },
    }),
    getNPSResponses: builder.query({
      query: (params) => {
        return {
          url: `/api/reports/nps/responses/`,
          params,
        };
      },
    }),
  }),
});

export const {
  useGetNPSDashboardQuery,
  useLazyGetNPSDashboardQuery,
  useGetNPSResponsesQuery,
  useLazyGetNPSResponsesQuery,
} = npsAPI;

export default npsAPI;
